<template>
	<router-view v-if="showRouterView" />
	<v-overlay v-else :value="true" :dark="false" z-index="9999">
		<v-card>
			<v-card-text class="d-flex justify-center">
				<v-progress-circular :size="25" indeterminate color="primary" />
				<span class="mx-3 text-button">Loading user profile</span>
			</v-card-text>
		</v-card>
	</v-overlay>
</template>
<script>
import { mapGetters } from 'vuex';
import { AuthGetterTypes, ClientContextGetters } from '../store/getters';
import { ClientContextActions } from '../store/actions';
export default {
	name: 'AuthenticatedContext',
	computed: {
		...mapGetters({
			profileLoaded: [AuthGetterTypes.PROFILE_LOADED],
			clientContextInitialized: [ClientContextGetters.INITIALIZE],
		}),
		showRouterView() {
			let result = true;
			if (!this.profileLoaded) result = false;
			if (!this.clientContextInitialized) result = false;
			return result;
		},
	},
	mounted() {
		this.$store.dispatch(ClientContextActions.LOAD_CLIENT_CONTEXT);
	},
};
</script>
